export const getImageInputIdentifiers = (fields, imageInputIdentifiers = []) => {
    fields.forEach((field) => {
      if (field.children) {
        // eslint-disable-next-line no-param-reassign
        if (['image', 'sketch', 'barcode', 'signature'].includes(field.type)) {
          imageInputIdentifiers.push(field.identifier);
        }
        imageInputIdentifiers = getImageInputIdentifiers(
          field.children,
          imageInputIdentifiers
        );
      } else {
        if (['image', 'sketch', 'barcode', 'signature'].includes(field.type)) {
          imageInputIdentifiers.push(field.identifier);
        }
      }
    }, []);

    return imageInputIdentifiers;
  };